import * as React from "react";
import { useContext, useReducer, useState } from "react";
import { AppDispatch, AppState } from "../../../../../Domain/Context";
import { globalState } from "../../../../../Domain/HeaderState";
import { LocationSearchBarType } from "./LocationSearchBar.types";
import { globalReducer } from "../../../SearchHeader/SearchHeaderEvent";
import { ToolbarContainer } from "./LocationSearchBar.styles";
import { LocationSearchTextFieldOpts } from "./LocationSearchToolbar.types";
import { LocationSearchTextField } from "./LocationSearchTextField";

export function LocationSearchBar(props: LocationSearchBarType) {
    const [state, dispatch] = useReducer(globalReducer, globalState);

    return (
        <AppDispatch.Provider value={dispatch}>
            <AppState.Provider value={state}>
                <WrappedRoot {...props} />
            </AppState.Provider>
        </AppDispatch.Provider>
    );
}

function WrappedRoot(props: LocationSearchBarType) {
    const { determineUserAddress } = props;

    const dispatch = useContext(AppDispatch);

    const [searchInput, setSearchInput] = useState("");

    function onSearch(value: string) {
        setSearchInput(value);
        props.debouncedSearch(value, dispatch, { groupId: props.groupId });
    }

    const searchTextFieldOpts: LocationSearchTextFieldOpts = {
        searchInput,
        onSearch,
        determineUserAddress,
    };

    return (
        <ToolbarContainer>
            <LocationSearchTextField {...searchTextFieldOpts} />
        </ToolbarContainer>
    );
}
